import { Container } from 'react-bootstrap'
import { AppLogo } from './AppLogo'
import { MenuToggler } from './MenuToggler'
import { ThemeToggler } from './ThemeToggler'
import { UserDropdown } from './UserDropdown'

export const TopBar = () => {
  return (
    <header className="app-topbar">
      <Container fluid className="topbar-menu">
        <div className="d-flex align-items-center gap-2">
          <AppLogo />
          <MenuToggler />
        </div>
        <div className="d-flex align-items-center gap-2">
          <ThemeToggler />
          <UserDropdown />
        </div>
      </Container>
    </header>
  )
}
